import { Controller, useFormContext } from 'react-hook-form';
import { LanguageSelect, LanguageSelectProps } from './LanguageSelect';

export type LanguageFieldProps = Omit<
  LanguageSelectProps,
  'value' | 'onChange' | 'onBlur' | 'error' | 'disabled'
> & {
  /** Form field name (react-hook-form). */
  readonly name: string;
};

/**
 * React Hook Form field that wraps LanguageSelect. Use inside FormContainer.
 * Binds the language select to the form by field name and forwards validation state.
 */
export function LanguageField(props: LanguageFieldProps) {
  const { name, ...rest } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <LanguageSelect
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          disabled={field.disabled}
          error={fieldState.error?.message}
          {...rest}
        />
      )}
    />
  );
}
